
import axios from "axios";
import { ProductAssignmentSubmitPayload, UserProductAssignResponse } from "src/models/ProductAssignment";

const urlUsers = process.env.REACT_APP_GLOBAL_USERS_API_URL;
const apiKey = process.env.REACT_APP_GLOBAL_USERS_XAPIKEY;

export const postUserProductAssign = async (
    data: ProductAssignmentSubmitPayload,
    token: string,
): Promise<UserProductAssignResponse> => {
    const urlRequest = `${urlUsers}user_products/assign?country=MX`;
    const headers = {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-api-key': apiKey,
    };
    const res = await axios.post<UserProductAssignResponse>(urlRequest, data, { headers });
    return res.data;
};